import {
	Button,
	Col,
	Icon,
	Row,
	Spin,
	Table,
	Tabs,
} from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getPageSize } from '../utils/paging';
import styles from './config.css';
import {
	fetchDbs,
	editDb,
	editSource,
	onChangeTab,
	showCreateNew,
	showNewDbDialog,
	showNewSourceDialog,
	editSblGroup,
	showNewSblGroupDialog,
} from './configActions';
import iconStyle from '../components/icon.cs';

import ConfigDatabaseModalComponent from './dialogs/configDatabaseModalComponent';
import ConfigSourceModalComponent from './dialogs/configSourceModalComponent';
import ConfigSblGroupModalComponent from './dialogs/configSblGroupModalComponent';
import AiConfigInstructions from '../components/ai/config/Instructions.jsx';

const { Column } = Table;
const TabPane = Tabs.TabPane;

class ConfigComponent extends Component {
	state = {
		confirmDeleteVisible: false,
	};

	componentDidMount() {
		this.props.dispatch(fetchDbs());
	}

	showNewDialog() {
		if (this.props.activeTab === '1') {
			this.props.dispatch(showNewDbDialog());
		}
		if (this.props.activeTab === '2') {
			this.props.dispatch(showNewSblGroupDialog());
		}
		if (this.props.activeTab === '3') {
			this.props.dispatch(showNewSourceDialog());
		}
		if (this.props.activeTab === '4') {
			this.props.dispatch(showCreateNew(true));
		}
	}

	render() {
		const onRow = (obj) => ({
			onClick: () => {
				if (this.props.activeTab === '1') {
					this.props.dispatch(editDb(obj));
				}
				if (this.props.activeTab === '2') {
					this.props.dispatch(editSblGroup(obj));
				}
				if (this.props.activeTab === '3') {
					this.props.dispatch(editSource(obj));
				}
			},
		});

		return (
			<div>
				<Button
					icon='plus'
					type='primary'
					style={{ zIndex: 10000, position: 'absolute', right: 30 }}
					size='large'
					onClick={() => this.showNewDialog()}
				>
					Skapa ny
				</Button>

				<Row>
					<Spin spinning={this.props.loading}>
						<Col span={24}>
							<Tabs
								activeKey={this.props.activeTab}
								onChange={(activeTab) => this.props.dispatch(onChangeTab(activeTab))}
							>
								<TabPane tab='Databaser' key={'1'}>
									<ConfigDatabaseModalComponent />
									<Table
										dataSource={this.props.databases}
										size='small'
										pagination={{ pageSize: getPageSize(), position: 'bottom' }}
										onRow={onRow}
										style={styles.table}
									>
										<Column title='Bokstav' width={70} dataIndex='key' key='key' />
										<Column title='Namn' dataIndex='name' key='name' />
										<Column
											title='Ansvarig Jurist'
											dataIndex='responsibleLawyer'
											key='responsibleLawyer'
										/>
										<Column
											title='Dold för kund'
											dataIndex='hidden'
											key='hidden'
											render={(text, record, index) =>
												record.hidden ? <Icon type='check' style={iconStyle} /> : ''
											}
										/>
									</Table>
								</TabPane>
								<TabPane tab='Ämnesområden' key={'2'}>
									<ConfigSblGroupModalComponent />
									<Table
										dataSource={this.props.sblgroups}
										size='small'
										pagination={{ pageSize: getPageSize(), position: 'bottom' }}
										onRow={onRow}
										style={styles.table}
									>
										<Column title='Namn' dataIndex='name' key='name' />
										<Column title='Databaser' dataIndex='database' key='database' />
									</Table>
								</TabPane>
								<TabPane tab='Källor' key={'3'}>
									<ConfigSourceModalComponent />
									<Table
										dataSource={this.props.sources}
										size='small'
										pagination={{ pageSize: getPageSize(), position: 'bottom' }}
										onRow={onRow}
										style={styles.table}
									>
										<Column width={70} title='Id' dataIndex='id' key='id' />
										<Column title='Namn' dataIndex='fullName' key='fullName' />
									</Table>
								</TabPane>
								<TabPane tab='Ai Instruktioner' key={'4'}>
									<AiConfigInstructions
										displayCreateNew={this.props.showCreateNew}
										onCreateNew={() => {
											this.props.dispatch(showCreateNew(false));
										}}
										onCancel={() => {
											this.props.dispatch(showCreateNew(false));
										}}
									/>
								</TabPane>
							</Tabs>
						</Col>
					</Spin>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	loading: state.config.loading,
	databases: state.config.databases,
	sources: state.config.sources,
	sblgroups: state.config.sblgroups,
	db: state.config.db,
	activeTab: state.config.activeTab,
	showCreateNew: state.config.showCreateNew,
});

export default connect(mapStateToProps)(ConfigComponent);



// WEBPACK FOOTER //
// ./src/config/configComponent.js